import * as React from "react";

import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { type WithClassName } from "@client/types";
import ItemComponent from "./Item/container";

import "./style.less";

export type SocialIconsContainerProps = RootContainerProps &
  WithClassName & {
    itemsIds: string[];
    style: React.CSSProperties;
  };

export default ({ itemsIds, ...props }: SocialIconsContainerProps) => (
  <Container className="wsc_content_social_icons" {...getContainerProps(props)}>
    <ul className={props.className} style={props.style}>
      {itemsIds.map((x) => (
        <ItemComponent key={x} {...getRootContainerProps(props)} parentId={props.id} id={x} />
      ))}
    </ul>
  </Container>
);
